$( document ).ready(function() {
   $('.image-slider').slick({
      autoplay: true,
    autoplaySpeed: 1000,
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
     prevArrow: '<button class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
            nextArrow: '<button class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

   $('.feature-product').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
     prevArrow: '<button class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
            nextArrow: '<button class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

//dropdown class add and remove active class
  $(".result-menu").hover(function () {
    $(this).toggleClass("result_hover");
});

$('li.customs-submenu').hover(function() {
    $(this).find('.complete-menu').toggleClass('custom-open-menu ');
});

// price change script product page  start

   $(".plus-minus .reduced.items.qty_btns").trigger("click");
  
$("#qty").keyup(function(){
 var vall = $("#qty").val();
 $("#qty").attr("value",vall);
 embroideryData();
 screenPrintData();
  heattransferData();
})
  
$(".qty_btns").click(function(){ 
 var vall = $("#qty").val();
 $("#qty").attr("value",vall);
 
 embroideryData();
 screenPrintData(); 
   heattransferData();
})

 $('#embroidery').change(function(){
  if($('#embroidery').is(':checked')){
  var varName = $("#emb_product").attr("EmbvarName");
  var vIDD = $("#emb_product").attr("embroidery");
 $(".atc_btn").attr("embroidery",vIDD);
 $(".atc_btn").attr("EmbvarName",varName);
  }else{
       console.log("unchecked"); 
     $(".atc_btn").removeAttr("embroidery");
    $(".atc_btn").removeAttr("EmbvarName");
   }
})

/// to get embroidery price according to qty
$("#emb_product li").click(function(){
  var vID = $(this).attr("varid");
   console.log(vID);  
  var price = $(this).attr("price");
  var varName = $(this).attr("Name");
  $("#extra_price").text(price);

 // send data in atc btn
  $("#emb_product").attr("embroidery",vID);
  $("#emb_product").attr("EmbvarName",varName);
  if($('#embroidery').is(':checked')){
  $(".atc_btn").attr("embroidery",vID);
    $(".atc_btn").attr("EmbvarName",varName);
  }
})
// end



 $('#scrnprint').change(function(){
  if($('#scrnprint').is(':checked')){
   var varName = $("#scrnprint_product").attr("ScrvarName");
  var vIDD = $("#scrnprint_product").attr("scrnprint");
 if(($("#qty").val())  >=36  ){
   $(".atc_btn").attr("scrnprint",vIDD);
   $(".atc_btn").attr("ScrvarName",varName);
 }else{ 
     $(".atc_btn").removeAttr("scrnprint");
   }
  }else{
       console.log("unchecked"); 
     $(".atc_btn").removeAttr("scrnprint");
    $(".atc_btn").removeAttr("ScrvarName");
   }
})

/// to get Screen Print Item price according to qty
$("#scrnprint_product li").click(function(){
  var vID = $(this).attr("varid");
   console.log(vID);  
  var price = $(this).attr("price");
  var varName = $(this).attr("Name");
  $("#scrnprintextra_price").text(price);
  //$("#heatscrnprintextra_price").text(price);

 // send data in atc btn
  $("#scrnprint_product").attr("scrnprint",vID);
  $("#scrnprint_product").attr("ScrvarName",varName);
  if($('#scrnprint').is(':checked')){
    if(($("#qty").val())  >=36  ){
     $(".atc_btn").attr("scrnprint",vID);
     $(".atc_btn").attr("ScrvarName",varName);
   }
  }
})
// end
   $('#heattransfers').change(function(){
  if($('#heattransfers').is(':checked')){
   var varName = $("#heat_product").attr("HeatName");
  var vIDD = $("#heat_product").attr("heattransfer");
 if(($("#qty").val())  >=10  ){
   $(".atc_btn").attr("heattransfer",vIDD);
   $(".atc_btn").attr("HeatName",varName);
 }else{ 
     $(".atc_btn").removeAttr("heattransfer");
   }
  }else{
       console.log("unchecked"); 
     $(".atc_btn").removeAttr("heattransfer");
    $(".atc_btn").removeAttr("HeatName");
   }
})

/// to get Heat Transfer Item price according to qty
$("#heat_product li").click(function(){
  var vID = $(this).attr("varid");
   console.log(vID);  
  var price = $(this).attr("price");
  var varName = $(this).attr("Name");
 // $("#scrnprintextra_price").text(price);
 $("#heatscrnprintextra_price").text(price);

 // send data in atc btn
  $("#heat_product").attr("heattransfer",vID);
  $("#heat_product").attr("HeatName",varName);
  if($('#heattransfers').is(':checked')){
    if(($("#qty").val())  >=10  ){
     $(".atc_btn").attr("heattransfer",vID);
     $(".atc_btn").attr("HeatName",varName);
   }
  }
})
// end
  
/// Send Embroidery Product With Main Product
$("button.atc_btn").click(function(){
var def_txt = $("button#custom_atc_btn .btn_txt").text();
$("button#custom_atc_btn .btn_txt").text("Adding...");
 data = {
      "id": $(this).attr("varid"),
      "quantity": $("#qty").val(),
       properties: {
          "Embroidery Item": $("button.atc_btn").attr("EmbvarName"),
          "Screen Print Item": $("button.atc_btn").attr("scrvarname"),
         "Heat Transfer Print Item": $("button.atc_btn").attr("HeatName")  
         }
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
      console.log("qty updated");
       // window.location.href = '/cart'; 
         jQuery.getJSON('/cart.js', function (cart, textStatus) {
          var carttext=cart.item_count;
         console.log("fst "+carttext);
         //window.location.href = '/cart'; 
       });
      }
    });     //// Main product atc ends

setTimeout(function(){
 if($('#embroidery').is(':checked')){
      console.log("checked"); 
       data = {
      "id": $("button.atc_btn").attr("embroidery"),
      "quantity": $("#qty").val(),
       properties: {
                    'For Product': $(".product-name.top-product-detail span.lang1").text()
                   }     
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
      console.log("qty updated");
       // window.location.href = '/cart'; 
         jQuery.getJSON('/cart.js', function (cart, textStatus) {
          var carttext=cart.item_count;
         console.log("fst "+carttext);
         //window.location.href = '/cart'; 
       });
      }
    });


  }else{
       console.log("unchecked");
 }     ///// Embropidery Items added
 },600);

setTimeout(function(){
if($('#scrnprint').is(':checked')){    //// To add Screen Print Items Price 
      console.log("checked"); 
       data = {
      "id": $("button.atc_btn").attr("scrnprint"),
      "quantity": $("#qty").val(),
       properties: {
                    'For Product': $(".product-name.top-product-detail span.lang1").text()
                   }
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
      console.log("qty updated");
       // window.location.href = '/cart'; 
         jQuery.getJSON('/cart.js', function (cart, textStatus) {
          var carttext=cart.item_count;
         console.log("fst "+carttext);
         //window.location.href = '/cart'; 
       });
      }
    });
  ////////////// To add Setup Fee Product as well
setTimeout(function(){
  data = {
      "id": $("#scrnprint_product").attr("setup_feeVID"),
      "quantity": 1,
       properties: {
                  'For Product': $(".product-name.top-product-detail span.lang1").text()
                 }
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
      console.log("qty updated");
       // window.location.href = '/cart'; 
         jQuery.getJSON('/cart.js', function (cart, textStatus) {
          var carttext=cart.item_count;
         console.log("fst "+carttext);
         //window.location.href = '/cart'; 
       });
      }
    });
  },1400);

  }
 },1200);

 //Heat Transfer
  setTimeout(function(){
if($('#heattransfers').is(':checked')){    //// To add Screen Print Items Price 
      console.log("checked"); 
       data = {
      "id": $("button.atc_btn").attr("heattransfer"),
      "quantity": $("#qty").val(),
       properties: {
                    'For Product': $(".product-name.top-product-detail span.lang1").text()
                   }
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
      console.log("qty updated");
       // window.location.href = '/cart'; 
         jQuery.getJSON('/cart.js', function (cart, textStatus) {
          var carttext=cart.item_count;
         console.log("fst "+carttext);
         //window.location.href = '/cart'; 
       });
      }
    });
  ////////////// To add Setup Fee Product as well
setTimeout(function(){
  data = {
      "id": $("#heat_product").attr("setup_feeVID"),
      "quantity": 1,
       properties: {
                  'For Product': $(".product-name.top-product-detail span.lang1").text()
                 }
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
      console.log("qty updated");
       // window.location.href = '/cart'; 
         jQuery.getJSON('/cart.js', function (cart, textStatus) {
          var carttext=cart.item_count;
         console.log("fst "+carttext);
         //window.location.href = '/cart'; 
       });
      }
    });
  },1400);

  }
 },1200);
  //end heat

  setTimeout(function(){
   $("button#custom_atc_btn .btn_txt").text(def_txt);
    window.location.href = '/cart'; 
   },1400)

})
/// End 




function embroideryData(){
// get price and variant to add
if(($("#qty").val())  <=5  ){
  $("#emb_1").trigger("click");
}else if(($("#qty").val())  >=6 && ($("#qty").val()) <= 11){
  $("#emb_2").trigger("click");
}else if(($("#qty").val())  >=12 && ($("#qty").val()) <= 35){
  $("#emb_3").trigger("click");
}else if(($("#qty").val())  >=36 && ($("#qty").val()) <= 71){
  $("#emb_4").trigger("click");
}else if(($("#qty").val())  >=72 && ($("#qty").val()) <= 143){
  $("#emb_5").trigger("click");
}
// else if(($("#qty").val())  >=100 && ($("#qty").val()) <= 249){
//   $("#emb_6").trigger("click");
// }else if(($("#qty").val())  >=250 ){
//   $("#emb_7").trigger("click");
// }
  if(($("#qty").val())  >=144 ){
    
    $(".get-quote").show();
    $(".embroidery_main.extra_opt").hide();
    $('.modficion_items.two_field').hide();
    $('.modficion_items.three_field').hide();
    $(".embroidery_main.extra_opt").parents('.product-options-bottom').find('.custmify_button').hide();
  }
else{
    $(".get-quote").hide();  
    $(".embroidery_main.extra_opt").show();
    $('.modficion_items.two_field').show();
    $('.modficion_items.three_field').show();
    $(".embroidery_main.extra_opt").parents('.product-options-bottom').find('.custmify_button').show();
  }  
//   if(($("#qty").val())  <144 ){
//      $(".get-quote").hide();
//     $(".embroidery_main.extra_opt").show();
   
// }
  
}
function screenPrintData(){
 /// For Screen Print Items
if(($("#qty").val())  <36  ){
  $(".atc_btn").removeAttr("scrnprint");
  $(".atc_btn").attr("ScrvarName");
  $(".scrnprint_main").hide();
}else if(($("#qty").val())  ==36  ){
  $(".scrnprint_main").show();
  $("#scrprint_1").trigger("click");
  }else if(($("#qty").val())  >36 && ($("#qty").val()) <= 72){
    $("#scrprint_2").trigger("click");  $(".scrnprint_main").show();
  }else if(($("#qty").val())  >=73 && ($("#qty").val()) <= 143){
    $("#scrprint_3").trigger("click");  $(".scrnprint_main").show();
  }else if(($("#qty").val())  >=144 && ($("#qty").val()) <= 287){
    $("#scrprint_4").trigger("click");  $(".scrnprint_main").show();
  }else if(($("#qty").val())  >=288 && ($("#qty").val()) <= 499){
    $("#scrprint_5").trigger("click");  $(".scrnprint_main").show();
  }
  if(($("#qty").val())  >=500 ){
     $(".get-quote").show();
    $(".scrnprint_main.extra_opt").hide(); 
  }
 
}

  function heattransferData(){
 /// For Heat Transfer Items
if(($("#qty").val())  <10  ){
  $(".atc_btn").removeAttr("heattransfer");
  $(".atc_btn").attr("HeatName");
  $(".heat_main").hide();
}else if(($("#qty").val())  ==10  ){
  $(".heat_main").show();
  $("#heat_1").trigger("click");
  }else if(($("#qty").val())  >10 && ($("#qty").val()) <= 22){
    $("#heat_2").trigger("click");  $(".heat_main").show();
  }else if(($("#qty").val())  >=23 && ($("#qty").val()) <= 143){
    $("#heat_3").trigger("click");  $(".heat_main").show();
  }else if(($("#qty").val())  >=144 && ($("#qty").val()) <= 287){
    $("#heat_4").trigger("click");  $(".heat_main").show();
  }else if(($("#qty").val())  >=288 && ($("#qty").val()) <= 499){
    $("#heat_5").trigger("click");  $(".heat_main").show();
  }
 
 
}
  
$("#emb_product li:nth-child(1)").trigger("click");  // set emb variant id on page load
$("#scrnprint_product li:nth-child(1)").trigger("click");  // set scrnprint variant id on page load
  $("#heat_product li:nth-child(1)").trigger("click");  // set heat transfer variant id on page load



// $('.plus-minus').click(function(event){
//     event.preventDefault();
// console.log('dsdsdsddsdsdsd');
//    var value_checked_status = $(this).parents('.custom_qty').find('.embroidery');
//      if (value_checked_status.prop('checked')==true){ 
//         var qty_val = $(this).parent().find('.custom_quantity').val();
//         var calculated_val = $(this).parents('.custom_qty').find('.calulate_price').val();
//         var fixed_price = $(this).parents('.custom_qty').find('.fixed_price').val();
         
//        console.log('checked');
//        console.log('calculated_val',calculated_val);
//        console.log('fixed_price',fixed_price);
//        console.log('qty_val',qty_val);
//         var final_price = calculated_val * qty_val;
//         var super_final_price =  parseFloat(final_price)+parseInt(fixed_price);
//         $(this).parents('.product__info-wrapper').find('.custom_price').html('<span class="price-item price-item--regular">'+super_final_price+' USD</span>');
//        var app_link = $(this).parents('.product__info-wrapper').find('#customify-link').attr('href');
//          var new_link = app_link += '?rahul';
//          $(this).parents('.product__info-wrapper').find('#customify-link').attr('href',new_link);
//          console.log('app_link', new_link);
//          console.log('final_price', final_price);
//          console.log('super_final_price', super_final_price);
//          localStorage.setItem('test', super_final_price);
//          console.log( localStorage.getItem('test'));
         
//     }else{
//          console.log('not checked')
//     }
// });
  
});